
import { FieldType } from '../types';

/** Format a stored raw value into its display representation. */
export function formatValue(type: FieldType, value: string | boolean): string {
  if (type === 'checkbox') return value ? 'Yes' : 'No';

  const str = String(value ?? '').trim();
  if (!str) return '';

  switch (type) {
    case 'currency': {
      const num = Number(str.replace(/[^0-9.-]/g, ''));
      if (Number.isNaN(num)) return str;
      return num.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    case 'percent': {
      const num = Number(str.replace(/[^0-9.-]/g, ''));
      if (Number.isNaN(num)) return str;
      return `${num.toFixed(3)}%`;
    }
    case 'date': {
      // Expect YYYY-MM-DD
      const parts = str.split('-');
      if (parts.length === 3) {
        const [y, m, d] = parts;
        return `${Number(m)}/${Number(d)}/${y}`;
      }
      return str;
    }
    default:
      return str;
  }
}

/** Initials from a full name, used for avatar chips. */
export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0]?.toUpperCase() ?? '')
    .join('');
}

